import { TELUGUINDIA } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Telugu India
const TESection: Section[] = [
  {
    name: '1: సూచన మరియు అవలోకనం',
    subSections: [
      {
        name: 'ముందుమాట',
        page: 3,
      },
      {
        name: 'ప్రయోజనం మరియు ఫీల్డ్గైడ్ అప్లికేషన్',
        page: 4,
      },
      {
        name: 'కీలక నిర్వచనాలు',
        page: 5,
      },
      {
        name: 'నియంత్రణల అధికారక్రమం',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'మోటార్ వాహనం – ట్రా ఫిక్ భద్రత',
        page: 9,
      },
      {
        name: 'ఎత్తు ప్రదేశాలలో పని చేయడం',
        page: 12,
      },
      {
        name: 'మొబైల్ ఆధారిత పరికరాలు (MPE)',
        page: 18,
      },
      {
        name: 'లాకౌట్ ట్యాగ్అవుట్ / ఎనర్జీఐసోలేషన',
        page: 22,
      },
      {
        name: 'విద్యుత్ పన',
        page: 25,
      },
      {
        name: 'పరిమిత స్థలం',
        page: 29,
      },
      {
        name: 'ఎక్కువ వస్తువులు మరియు నిల్',
        page: 32,
      },
      {
        name: 'రైల్కార్ భద్రత',
        page: 37,
      },
      {
        name: 'తవ్వకం మరియు కందకం పన',
        page: 41,
      },
      {
        name: 'లిఫ్టింగ్ మరియు రిగ్గింగ',
        page: 45,
      },
      {
        name: '్రమాదకరమైన పదార్థాలు',
        page: 49,
      },
      {
        name: 'వేడిగా ఉన్న పన',
        page: 52,
      },
    ],
  },
  {
    name: '3: అదనపు వనరుల మరియు సాధనాలు',
    subSections: [
      {
        name: 'నీటిపై మరియు చుట్టూ పని చేయడం',
        page: 56,
      },
      {
        name: 'వసతు వులను ్ వదిలివేయడం లేదా పడిపోవడం',
        page: 59,
      },
      {
        name: 'వాతావరణం/గ్యాస్ పరీక',
        page: 61,
      },
      {
        name: 'రసాయన ప్రమాద కమ్యూనికేషన',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargill భద్రత నిర్వహణ పద్ధతులు',
    subSections: [
      {
        name: 'కీలక పదజాలం',
        page: 70,
      },
      {
        name: 'సంఘటన తీవ్రమైన గాయ మరియు మరణం (SIF) నిర్ణయం',
        page: 72,
      },
      {
        name: 'తీవ్రమైన గాయం మరియు మరణ సంభావ్య (SIFp) వర్గీకరణ',
        page: 73,
      },
      {
        name: 'SIF స్వయంచాలక నిర్ణయ ప్రమాణాల పట్టిక',
        page: 74,
      },
      {
        name: 'మానవ మరియు సంస్థాగత పనితీరు (HOP)',
        page: 76,
      },
    ],
  },
];
const TETableofContent: TableOfContent = {
  language: 'te',
  sections: TESection,
  label: 'విషయ సూచిక',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (te_IN)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP పాకెట్ గైడ్',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Telugu.pdf',
  source: TELUGUINDIA,
};

export default TETableofContent;
